export const assistant = {
routeTitle: "Asistente de operaciones",
routeSubtitle: "Inteligencia de operaciones para sus activos",
inputModeText: "Prioridad al texto",
widget: {
showLess: "Mostrar menos",
showMore: "Mostrar más",
openAssistant: "Abrir el asistente",
live: "En Vivo",
assistantLabel: "Asistente",
headerSubtitle: "Pregunte, inspeccione, programe, reasigne o cree trabajo sin salir de esta pantalla.",
newConversation: "Nueva conversación",
close: "Cerrar",
newThread: "Nuevo hilo",
loadingConversation: "Cargando conversación…",
emptyTitle: "Chat operativo siempre activo",
emptyBody: "Comience con una instrucción natural. El asistente puede responder preguntas, proponer acciones y esperar su confirmación cuando un cambio sea importante.",
actorYou: "Tú",
actorAssistant: "Asistente",
usedWorkspaceData: "Se usaron datos del espacio de trabajo",
recommendationFallbackTitle: "Recomendación",
dictationInserting: "Insertando transcripción…",
dictationFinishing: "Finalizando dictado…",
dictationHeard: "Escuchado: {{transcript}}",
dictationListening: "Escuchando…",
messageInputLabel: "Mensaje al asistente",
messagePlaceholder: "Haz una pregunta o dile al asistente qué hacer",
messagePlaceholderShort: "Pregunta o pide algo…",
stopDictation: "Detener dictado",
dictateMessage: "Dictar mensaje",
sendingMessage: "Enviando mensaje",
sendMessage: "Enviar mensaje",
sending: "Enviando…",
send: "Enviar",
composerHintPhone: "Toque el micrófono para dictar.",
composerHintDesktop: "Toque el micrófono para dictar. `Enter` envía en teclados de hardware; `Shift + Enter` agrega una nueva línea.",
},
conversation: {
newSession: "Nueva sesión",
inputModeLabel: "Modo de entrada: {{mode}}",
modeHint: "Canal de transcripción listo para voz; el texto está activo ahora.",
retry: "Reintentar",
loadingHistory: "Cargando historial del asistente...",
emptyTitle: "Copiloto operacional",
emptyBody: "Solicite borradores de listas de control, programación de inspecciones, creación de órdenes de trabajo, estado del trabajo, reasignación, explicación de riesgos o recomendaciones para el siguiente paso.",
actorYou: "Tú",
actorAssistant: "Asistente",
messagePlaceholder: "Pídale al asistente que cree, explique, inspeccione, recomiende o reasigne",
},
quickPrompts: {
attention: "¿Qué necesita mi atención ahora mismo?",
inspectionTemplates: "¿Dónde gestiono las listas de control?",
requestsTriage: "¿Qué solicitudes necesitan clasificación?",
overdueJobs: "Mostrar órdenes de trabajo vencidas",
assetNextStep: "¿Qué debo hacer a continuación con este activo?",
assetOverdueInspections: "¿Hay inspecciones vencidas para este activo?",
assetRiskSummary: "Resumir el riesgo y el trabajo abierto de este activo",
scheduleNextInspection: "Programar la próxima inspección",
assetTopNextStep: "Recomendar el siguiente paso más prioritario para este activo",
assetOpenJobsFirst: "¿Qué órdenes de trabajo abiertas debo revisar primero?",
shouldScheduleInspection: "¿Debo programar una inspección?",
requestSummarize: "Resumir esta solicitud y sugerir cómo responder",
requestToJob: "Convertir esta solicitud en una orden de trabajo",
requestMissingInfo: "¿Qué información falta todavía para empezar el trabajo?",
requestOwner: "¿Quién debería encargarse de esta solicitud?",
requestFastestPath: "¿Cuál es la forma más rápida de convertir esta solicitud?",
requestDraftResponse: "Redactar una respuesta profesional para el solicitante",
requestJobOrInspection: "¿Debería convertirse en una orden de trabajo o en una inspección?",
inspectionFailedFindings: "Resumir los hallazgos no superados y sugerir órdenes de seguimiento",
inspectionMissingEvidence: "¿Qué evidencias faltan en esta inspección?",
inspectionHighestRisk: "Explicar los elementos no superados de mayor riesgo",
inspectionJobsFromUrgent: "Crear órdenes de trabajo a partir de hallazgos urgentes",
jobBlocking: "¿Qué impide completar esta orden de trabajo?",
jobNextUpdate: "Sugerir la próxima actualización que debo publicar",
jobWhoElse: "¿Quién más debería participar en esta orden de trabajo?",
jobFollowUp: "¿Qué trabajo de seguimiento podría hacer falta?",
jobNextStepToClose: "Recomendar el siguiente paso para cerrar esta orden de trabajo",
jobDraftCompletionNote: "Redactar una nota de finalización",
jobCreateFollowUp: "¿Debo crear una orden de trabajo de seguimiento?",
templateImprove: "¿Cómo puedo mejorar esta lista de control?",
templateMissingChecks: "¿Qué comprobaciones faltan para este tipo de activo?",
templateWeekly: "Generar una lista de control práctica de inspección semanal",
templateWhereManage: "¿Dónde gestiono las listas de control en la aplicación?",
},
  card: {
    edit: 'Editar',
    doneEditing: 'Listo',
    editHint: 'Cambia lo que quieras antes de confirmar.',
    confirming: 'Confirmando…',
    dismiss: 'Descartar',
    working: 'Procesando…',
    undo: 'Deshacer',
    undoing: 'Deshaciendo…',
    undone: 'Deshecho',
    undoHint: 'Puedes deshacerlo durante 10 minutos.',
    edited: 'Editado',
    fields: {
      name: 'Nombre',
      description: 'Descripción',
      placeType: 'Tipo de lugar',
      address: 'Dirección',
      externalId: 'Referencia',
      code: 'Código',
      scheduledDate: 'Vence (fecha y hora)',
      notes: 'Notas',
      title: 'Título',
      dueDate: 'Vence (fecha y hora)',
      estimatedCost: 'Estimación',
      note: 'Actualización',
      responseText: 'Respuesta',
    },
  },
  chart: {
    summary_one: '{{title}}: {{from}}',
    summary_many: '{{title}}: de {{from}} a {{to}}, {{count}} puntos',
    summary_other: '{{title}}: de {{from}} a {{to}}, {{count}} puntos',
  },
  context: {
    selectedAssets_one: "Pregunta sobre {{count}} activo seleccionado",
    selectedAssets_many: "Pregunta sobre {{count}} activos seleccionados",
    selectedAssets_other: "Pregunta sobre {{count}} activos seleccionados",
    leaveOut: "Dejar fuera la selección",
  },
  memory: {
    title: "Lo que recuerda el asistente",
    intro: "Preferencias para todo el espacio de trabajo, como cómo llamáis a las cosas o quién suele recibir un tipo de trabajo. El asistente las sigue al responder. Todos en el espacio de trabajo pueden verlas.",
    empty: "Todavía nada. Añade una aquí o pídeselo al asistente, por ejemplo «Recuerda que los trabajos de seguridad del gas van a Northside Heating».",
    addPlaceholder: "Algo que el asistente debe recordar",
    add: "Añadir",
    edit: "Editar",
    save: "Guardar",
    cancel: "Cancelar",
    forget: "Olvidar",
    viaAssistant: "Añadido a través del asistente",
    added: "Añadido por alguien del espacio de trabajo",
    full: "El asistente recuerda {{max}} cosas, el máximo. Olvida una para añadir otra.",
    saveFailed: "No se ha guardado. Solo puedes cambiar lo que añadiste tú, salvo que seas administrador del espacio de trabajo.",
  },
  offline: {
    waiting: "Estás sin conexión. Se enviará cuando vuelvas a estar en línea.",
    sending: "De nuevo en línea. Enviando…",
    fromGuide: "Mientras tanto, la guía de la app puede ayudarte:",
    discard: "No enviar",
    photoNeedsConnection: "Una foto necesita conexión. Quítala para que la pregunta se envíe cuando vuelvas a estar en línea, o inténtalo entonces.",
    queueFull: "Ya hay 10 preguntas esperando. Espera a volver a estar en línea.",
  },
  stream: {
    thinking: "Trabajando en ello…",
    lookingUp_one: "Consultando datos ({{count}} hasta ahora)…",
    lookingUp_many: "Consultando datos ({{count}} hasta ahora)…",
    lookingUp_other: "Consultando datos ({{count}} hasta ahora)…",
  },
  voice: {
    readAloud: "Leer las respuestas en voz alta",
    stopReading: "Dejar de leer las respuestas",
    readingAloud: "Las respuestas se leen en voz alta.",
    handsFree: "Manos libres",
    handsFreeOn: "Manos libres: tras cada respuesta escucha tu siguiente pregunta.",
  },
  briefing: {
    title: 'Esta semana',
    stopSuggesting: 'No sugerir esto',
    hideWeek: 'Ocultar hasta la próxima semana',
    turnOff: 'Desactivar el resumen semanal',
    settingsTitle: 'Tu resumen semanal',
    settingsIntro: 'Un breve resumen de tu semana y algunas preguntas sugeridas arriba del asistente. Es tu propio ajuste.',
    on: 'Activado',
    off: 'Desactivado',
    suggestionsOff_one: '{{count}} tipo de sugerencia está desactivado.',
    suggestionsOff_many: '{{count}} tipos de sugerencia están desactivados.',
    suggestionsOff_other: '{{count}} tipos de sugerencia están desactivados.',
    suggestionsBackOn: 'Volver a activar las sugerencias',
  },
  photo: {
    add: "Añadir una foto",
    replace: "Cambiar la foto",
    remove: "Quitar la foto",
    attached: "Foto adjunta. El asistente la lee una vez y no la guarda.",
    addTitle: "Añadir una foto",
    addBody: "Haz una foto o elige una. El asistente lee placas de características, lecturas y daños.",
    take: "Hacer foto",
    choose: "Elegir foto",
    cancel: "Cancelar",
    permissionTitle: "Permiso necesario",
    cameraPermissionBody: "Permite el acceso a la cámara en Ajustes para hacer una foto para el asistente.",
    libraryPermissionBody: "Permite el acceso a las fotos en Ajustes para elegir una foto para el asistente.",
    failedTitle: "Foto no añadida",
    failedBody: "No se pudo abrir esa foto. Prueba con otra.",
    defaultMessage: "¿Qué muestra esta foto?",
  },
  activity: {
    title: 'Actividad del asistente',
    subtitleAdmin: 'Todos los cambios hechos con el asistente en este espacio',
    subtitleMember: 'Los cambios que hiciste con el asistente',
    policyTitle: 'Quién puede hacer cambios con el asistente',
    policyIntroAdmin: 'Cada persona mantiene sus permisos: el asistente solo hace lo que esa persona podría hacer en la app.',
    policy: {
      everyone: 'Todos',
      admins: 'Propietarios y administradores',
      nobody: 'Nadie',
    },
    policyHelp: {
      everyone: 'Los miembros pueden confirmar los cambios que prepara el asistente, según sus permisos.',
      admins: 'Los miembros pueden preguntar; solo propietarios y administradores confirman cambios.',
      nobody: 'El asistente responde y aconseja, pero no cambia nada. Las solicitudes de funciones se siguen enviando.',
    },
    policyMember: {
      everyone: 'Puedes confirmar los cambios que prepara el asistente, según tus permisos.',
      admins: 'En este espacio solo propietarios y administradores hacen cambios con el asistente. Puedes seguir preguntándole.',
      nobody: 'Este espacio ha desactivado los cambios con el asistente. Puedes seguir preguntándole.',
    },
    saving: 'Guardando…',
    saveFailed: 'No se pudo guardar el ajuste.',
    loadFailed: 'No se pudo cargar la actividad del asistente.',
    refresh: 'Actualizar',
    count_one: '{{count}} cambio',
    count_many: '{{count}} cambios',
    count_other: '{{count}} cambios',
    empty: 'Todavía no hay cambios hechos con el asistente.',
    status: {
      executed: 'Hecho',
      failed: 'Error',
      undone: 'Deshecho',
    },
    byYou: 'por ti',
    byPerson: 'por {{name}}',
  },
};
